import { render, staticRenderFns } from "./case-details.vue?vue&type=template&id=56e6a889&scoped=true&"
import script from "./case-details.vue?vue&type=script&lang=js&"
export * from "./case-details.vue?vue&type=script&lang=js&"
import style0 from "./case-details.vue?vue&type=style&index=0&id=56e6a889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e6a889",
  null
  
)

export default component.exports